import Vue from 'vue';
import Vuetify, {
    VCarousel
} from 'vuetify/lib';

Vue.use(Vuetify,{
    components:{
        VCarousel
    }
});

export default new Vuetify({
});
